import { Link } from '@hc-frontend/core-ui';
import { addClassName } from '@hc-frontend/core-utils-format';

import type { CallCtaProps } from './call-cta.types';

export function CallCta({
  phoneCampaign,
  className,
  children,
  ...otherProps
}: CallCtaProps) {
  return (
    <Link
      data-call-call-type={phoneCampaign.callType}
      data-call-placement={phoneCampaign.placement}
      data-call-product={phoneCampaign.product}
      data-call-phone={phoneCampaign.href}
      data-call-advertiser={phoneCampaign.advertiser}
      {...otherProps}
      className={addClassName(
        'hc-btn--primary-card bg-secondary-900',
        className,
      )}
      href={phoneCampaign.href}
      id="call_now_button"
    >
      {children}
    </Link>
  );
}
